var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{attrs:{"align-v":"baseline"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('b-checkbox',{attrs:{"checked":_vm.selected},on:{"input":(value) => _vm.$emit('select', value)}})],1),_c('b-col',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }